import React, { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Box, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import GroupIcon from "@material-ui/icons/Group";
import { useQuery } from "@apollo/client";
import { GET_CITIZEN_MENU } from "../../../../../../quries/citizenJoy";

const useStyles = makeStyles((theme) =>
  createStyles({
    topContainer: {
      paddingLeft: 16,
      paddingBottom: 8,
    },
    iconDiv: {
      //   paddingRight: 16,
    },
    textDiv: {
      fontSize: 16,
    },
    aspectRatioBox: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      borderRadius: 12,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      textAlign: "center",
      fontSize: 20,
      color: "white",
      background: "no-repeat center center",
      backgroundImage: "url(/images/history/3.png)",
      backgroundSize: "100%",
    },

    topCategory: {
      //   paddingRight: 8,
      fontSize: 16,
      fontFamily: "Noto Sans KR",
      fontWeight: 700,
      paddingBottom: 8,
    },
    menuTitle: {
      fontFamily: "Noto Sans KR",
      fontSize: 14,
      fontWeight: 400,
      paddingLeft: 16,
      paddingTop: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  })
);

interface MoCitizenJoyMenuProps {
  setOpen: any;
  setExpanded:any
}

function MoCitizenJoyMenu({ setOpen,setExpanded }: MoCitizenJoyMenuProps) {
  const classes = useStyles();
  const [feat_img, setFeatImg] = useState<any>(null);
  const [citizenJoyArr, setCitizenJoyArr] = useState<any>(null);
  const [citizenActualJoyArr, setActualCitizenJoyArr] = useState<any>([]);
  const [title, setTitle] = useState<any>(null);
  const [parentId, setParentId] = useState<any>(null);
  const [subMenu, setSubMenu] = useState<any>(null);

  const { data, loading, error } = useQuery(GET_CITIZEN_MENU, {
    variables: {
      limit: 0,
      sort: "created_at:DESC",
    },
  });

  useEffect(() => {
    if (data && data.citizenJoyPrograms) {
      if (data.citizenJoyPrograms.length > 0) {
        let citizenJoyPrograms = data.citizenJoyPrograms[0];
        for (let i = 0; i < 3; i++) {
          setActualCitizenJoyArr((prev: any) => {
            return [...prev, data.citizenJoyPrograms[i]];
          });
        }
        setCitizenJoyArr(data.citizenJoyPrograms);
        setFeatImg(citizenJoyPrograms.feat_img.url);
      }
    }
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.citizenJoyPrograms) {
    console.log(error);
  }

  return (
    <Grid xs={12} item container style={{ paddingTop: 16, paddingBottom: 16 }}>
      <Grid xs={12} item container className={classes.topCategory}>
        <Grid xs={1} item className={classes.iconDiv}>
          <GroupIcon />
        </Grid>
        <Grid item xs={11} className={classes.textDiv}>
          시민참여 (공모전)
        </Grid>
        {/* <Grid item xs={1} component={animated.div}>
            <ArrowBackIcon style={{}} />
          </Grid> */}
      </Grid>

      <Grid xs={12} item style={{ padding: 16 }} container>
        <Grid xs={6} item style={{ paddingRight: 24 }}>
          <Box component={"div"} className={classes.aspectRatioBox}>
            <Box
              component={"div"}
              className={classes.aspectRatioBoxInside}
              style={{ backgroundImage: `url(${feat_img})` }}
            ></Box>
          </Box>
        </Grid>

        <Grid
          item
          style={{
            fontSize: 16,
            fontWeight: 700,
            // paddingBottom: 24,
            // paddingTop: 24,
          }}
          xs={6}
        >
          <Grid item xs={12} style={{}}>
            {citizenJoyArr && citizenActualJoyArr ? (
              citizenJoyArr.length > 3 ? (
                citizenActualJoyArr.map((element: any, index: any) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      key={`citizen-joy/-${element.title}-${index}`}
                      className={classes.menuTitle}
                    >
                      <Link
                        to={`/citizen-joy/${element.id}`}
                        onClick={() => {
                          setOpen(false);
                          setExpanded(false);
                        }}
                      >
                        {element.title}
                      </Link>
                    </Grid>
                  );
                })
              ) : (
                citizenJoyArr.map((element: any, index: any) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      key={`citizen-joy/-${element.title}-${index}`}
                      className={classes.menuTitle}
                    >
                      <Link
                        to={`/citizen-joy/${element.id}`}
                        onClick={() => {
                          setOpen(false);
                          setExpanded(false);
                        }}
                      >
                        {element.title}
                      </Link>
                    </Grid>
                  );
                })
              )
            ) : (
              <div></div>
            )}
            {citizenJoyArr && citizenJoyArr.length > 3 ? (
              <Link
                to={`/citizen-joy/`}
                onClick={() => {
                  setOpen(false);
                  setExpanded(false);
                }}
              >
                <Grid
                  style={{
                    fontFamily: "Noto Sans KR",
                    color: "#5a5a5a",
                    fontSize: 14,
                    fontWeight: 600,
                    paddingLeft: 16,
                    paddingTop: 16,
                  }}
                >
                  더보기
                </Grid>
              </Link>
            ) : (
              <div></div>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MoCitizenJoyMenu;
